import { render, staticRenderFns } from "./PartnerCurrentWithholdList.vue?vue&type=template&id=488cafc8&scoped=true&"
import script from "./PartnerCurrentWithholdList.vue?vue&type=script&lang=js&"
export * from "./PartnerCurrentWithholdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488cafc8",
  null
  
)

export default component.exports